import { getDiscount } from '../../../utils/functions';
import StarIcon from '@mui/icons-material/Star';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addToWishlist, removeFromWishlist } from '../../../actions/wishlistAction';
import { useSnackbar } from 'notistack';
import { Box, Typography, IconButton, Paper, Rating } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Product = (props) => {
    const { _id, name, images, ratings = 0, numOfReviews = 0, price = 0, mrp = 0, brand } = props;
    const theme = useTheme();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const { wishlistItems } = useSelector((state) => state.wishlist);
    const itemInWishlist = wishlistItems.some((i) => i.product === _id);

    const addToWishlistHandler = () => {
        if (itemInWishlist) {
            dispatch(removeFromWishlist(_id));
            enqueueSnackbar("Removed from Wishlist", { variant: "success" });
        } else {
            dispatch(addToWishlist(_id));
            enqueueSnackbar("Added to Wishlist", { variant: "success" });
        }
    };

    const imageUrlBase = images?.[0]?.lowUrl;

    return (
        <Paper
            elevation={3}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                p: 2,
                m: 1,
                position: 'relative',
                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: theme.shadows[6],
                },
            }}
        >
            <Link to={`/product/${_id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ width: 144, height: 144 }}>
                    <img
                        draggable="false"
                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        src={`${imageUrlBase}?w=400`} // Fallback src
                        // Provide multiple image sizes for the browser to choose from
                        srcSet={`${imageUrlBase}?w=200 200w, ${imageUrlBase}?w=400 400w, ${imageUrlBase}?w=600 600w`}
                        // Tell the browser the image is about 144px wide
                        sizes="144px"
                        alt={name}
                        loading="lazy" // Defer loading of off-screen images
                    />
                </Box>
                <Typography
                    variant="subtitle2"
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        minHeight: '3em',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        mt: 1 // Adjusted margin-top
                    }}
                >
                    {name}
                </Typography>
            </Link>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}> {/* Adjusted gap */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}> {/* Adjusted gap */}
                    <Rating name="read-only" value={ratings} readOnly precision={0.5} size="small" />
                    <Typography variant="body2" color="text.secondary">
                        ({numOfReviews.toLocaleString()})
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                    <Typography variant="h6">₹{price.toLocaleString()}</Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ textDecoration: 'line-through' }}
                    >
                        ₹{mrp.toLocaleString()}
                    </Typography>
                    <Typography variant="body2" color="success.main">
                        {getDiscount(price, mrp)}% off
                    </Typography>
                </Box>
            </Box>

            <IconButton
                onClick={addToWishlistHandler}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    color: itemInWishlist ? theme.palette.error.main : theme.palette.action.disabled,
                }}
            >
                <FavoriteIcon />
            </IconButton>
        </Paper>
    );
};

export default Product;
